module.exports = __webpack_public_path__ + "static/media/featureQuality_illust.51be9fba.jpg";